// Externe Bibliotheken
import React, { Component } from 'react';

// Interne Module
import { convertDate, convertDateToGerman, convertPrice } from '@/_helper/mapper';
import _ from 'lodash';
import * as storage from '@/_helper/storage';
import getDurationDays, { getShortWeekday, mapRooms } from '@/_helper/bookingDetailsHelper';
import { AppContext } from '@/context/AppContext';
import Icon from '@/comp/icon/icon';

// Styles
import './travelFactsBooking.scss';
import InfoCard from '@/comp/ui/infoCard/infoCard';
import { Tooltip } from '@/comp/toolTip/tooltip.tsx';

class TravelFactsBooking extends Component {
    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            data: storage.get('bookingData').data,
        };
    }

    getHotelDetails() {
        if (this.state != null) {
            const { data } = this.state;

            if (
                data !== null &&
                data.frontendParams.hotelDetails !== undefined &&
                data.frontendParams.hotelDetails[0] !== undefined
            ) {
                const hotelDetails = data.frontendParams.hotelDetails;

                return (
                    <div className="line hotel-details">
                        <div>
                            <Icon name="home" ariaHidden />
                        </div>
                        <div className="booking-info">
                            <div className="title">Hotel</div>
                            {hotelDetails.map((hotel, index) => {
                                const starsContainer = [];

                                for (var i = 0; i < hotel.category; i++) {
                                    starsContainer.push(
                                        <Icon name="starFilled" size={16} ariaHidden key={`star-${i}`} />
                                    );
                                }

                                return (
                                    <div className="details-info" key={index}>
                                        <div className="name flex">
                                            <div>{hotel.name}</div>
                                            <div
                                                className="category flex flex-middle"
                                                category={hotel.category}
                                                aria-label={`${hotel.category} von 5 Sternen`}>
                                                {starsContainer}
                                            </div>
                                        </div>
                                        <div>{hotel.room}</div>
                                        <div>{hotel.meal}</div>
                                        <div>
                                            {convertDateToGerman(convertDate(hotel.checkIn), { weekday: 'short' })}.,{' '}
                                            {hotel.checkIn} -{' '}
                                            {convertDateToGerman(convertDate(hotel.checkOut), { weekday: 'short' })}.,{' '}
                                            {hotel.checkOut}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                );
            }
        }
    }

    getCruiseDetails() {
        if (this.state != null) {
            const { data } = this.state;
            if (data && data.frontendParams.cruise) {
                const cruiseDetails = data.frontendParams.cruise;
                const { itinerary, additionalTariffInfo, room, shipName, providerName, checkIn, checkOut } =
                    cruiseDetails;
                const isMediatedCruise = data?.frontendParams?.mediatedServices.cruise;
                const rooms = room?.details ?? [];
                const { name: itineraryName } = itinerary;

                return (
                    <div className="line cruise-details">
                        <div>
                            <span className="icon cruise">
                                <Icon name="directionsBoat300" size={25} />
                            </span>
                        </div>
                        <div className="booking-info">
                            <div className="title">{isMediatedCruise && 'Vermittelte '}Kreuzfahrt</div>
                            <div className="details-info">
                                <div>{itineraryName && <p>{itineraryName}</p>}</div>
                                <div>
                                    {shipName && <p>Schiff: {shipName}</p>}
                                    {providerName && <p>{providerName}</p>}
                                </div>
                                <div>
                                    {checkIn && checkOut && (
                                        <p>
                                            {getDurationDays(checkIn, checkOut)} Nächte vom {checkIn} bis {checkOut}
                                        </p>
                                    )}
                                </div>
                                <div>
                                    {rooms &&
                                        mapRooms(rooms).map((room, index) => (
                                            <p key={index}>
                                                {room?.count > 1 ? `${room?.count} ` : ''}
                                                {room?.name}&nbsp;&middot;&nbsp;{room?.meal}
                                            </p>
                                        ))}
                                </div>
                                <div>
                                    {additionalTariffInfo?.serviceCode && (
                                        <p>Tarif: {additionalTariffInfo.serviceCode}</p>
                                    )}
                                    {additionalTariffInfo?.promoCode && (
                                        <p>Tarifbeschreibung: {additionalTariffInfo.promoCode}</p>
                                    )}
                                    {additionalTariffInfo?.promoDescription && (
                                        <p>Inklusivleistungen: {additionalTariffInfo.promoDescription}</p>
                                    )}
                                </div>
                                {isMediatedCruise && (
                                    <div className="line">
                                        <InfoCard type="small">
                                            Die Kreuzfahrtleistung wurde im Namen und auf Rechnung der Reederei
                                            vermittelt. Die Rechnung mit sämtlichen Zahlungsinformationen wird Ihnen
                                            direkt von der Reederei übermittelt. Der Kreuzfahrtpreis ist an die Reederei
                                            zu entrichten.
                                        </InfoCard>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    getFlightDetails() {
        if (this.state != null) {
            const { data } = this.state;

            if (
                data !== null &&
                data.frontendParams.flightDetails !== undefined &&
                data.frontendParams.flightDetails.inbound !== undefined &&
                data.frontendParams.flightDetails.outbound !== undefined
            ) {
                const flightDetailsOutbound = data.frontendParams.flightDetails.outbound;
                const flightDetailsInbound = data.frontendParams.flightDetails.inbound;

                return (
                    <div className="line box flight-details">
                        <div>
                            <Icon name="flightTakeoff" ariaHidden />
                        </div>
                        <div className="booking-info">
                            <div className="title">Flug</div>
                            <div className="details-info">
                                {flightDetailsOutbound.map((flight, index) => {
                                    return (
                                        <div key={index}>
                                            <div>
                                                {flight.depAirportDescription} ({flight.depAirportCode}) -{' '}
                                                {flight.arrAirportDescription} ({flight.arrAirportCode}) -{' '}
                                                {flight.carrier}
                                                {flight.flightNumber}
                                            </div>
                                            <div>
                                                {convertDateToGerman(convertDate(flight.depDate), { weekday: 'short' })}
                                                ., {flight.depDate} - {flight.depTime} Uhr
                                            </div>
                                        </div>
                                    );
                                })}

                                {flightDetailsInbound.map((flight, index) => {
                                    return (
                                        <div key={index}>
                                            <div>
                                                {flight.depAirportDescription} ({flight.depAirportCode}) -{' '}
                                                {flight.arrAirportDescription} ({flight.arrAirportCode}) -{' '}
                                                {flight.carrier}
                                                {flight.flightNumber}
                                            </div>
                                            <div>
                                                {convertDateToGerman(convertDate(flight.depDate), { weekday: 'short' })}
                                                ., {flight.depDate} - {flight.depTime} Uhr
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    getTransferDetails() {
        if (this.state != null) {
            const { data } = this.state;

            if (data !== null && data.frontendParams.transferDetails !== undefined) {
                const transferDetails = data.frontendParams.transferDetails;

                return (
                    <div className="line transfer-details">
                        <div>
                            <Icon name="directionsBus" className="icon" ariaHidden />
                        </div>
                        <div className="booking-info">
                            <div className="title">Transfer</div>
                            <div className="details-info">
                                {window.$content.mappingTransfer[transferDetails?.tariff.toLowerCase()]
                                    ?.short_description !== undefined &&
                                    window.$content.mappingTransfer[transferDetails?.tariff.toLowerCase()]
                                        ?.short_description}
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    getExcursionDetails() {
        if (this.state != null) {
            const { data } = this.state;

            if (
                data !== null &&
                data.frontendParams?.excursions &&
                Object.keys(data.frontendParams.excursions).length > 0
            ) {
                const excursionDetails = data.frontendParams?.excursions;

                const activeExcursions = _.filter(excursionDetails, function (o) {
                    return o.state === 'OK';
                });
                const inactiveExcursions = _.filter(excursionDetails, function (o) {
                    return o.state !== 'OK';
                });

                return (
                    <div className="line excursion-details">
                        <div>
                            <Icon name="attractions" className="icon" ariaHidden />
                        </div>
                        <div className="booking-info">
                            <div className="title">Ausflug</div>
                            <div className="details-info">
                                {activeExcursions.length >= 1 && (
                                    <div className="active">
                                        {activeExcursions.map((value, index) => {
                                            let parts = value.description.split(' - ');
                                            return (
                                                <div key={`excursion-active-${index}`}>
                                                    {index > 0 && <hr />}
                                                    <div className="e">
                                                        <div className="item">
                                                            <div>{parts[0]}</div>
                                                            <div>{parts[1]}</div>
                                                        </div>
                                                        <div className="item">
                                                            <div>
                                                                {getShortWeekday(value.startDate) +
                                                                    '., ' +
                                                                    value.startDate}
                                                            </div>
                                                            <div>
                                                                {value.participants.length &&
                                                                    value.participants.length + ' Pers.'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                                {inactiveExcursions.length >= 1 && (
                                    <div className="inactive">
                                        <hr />
                                        {inactiveExcursions.map((value, index) => {
                                            let parts = value.description.split(' - ');
                                            return (
                                                <div key={`excursion-inactive-${index}`}>
                                                    {index > 0 && <hr />}
                                                    <div>
                                                        <span className="chip storno"></span>
                                                    </div>
                                                    <div className="e">
                                                        <div className="item">
                                                            <div>{parts[0]}</div>
                                                            <div>{parts[1]}</div>
                                                        </div>
                                                        <div className="item">
                                                            <div>
                                                                {getShortWeekday(value.startDate) +
                                                                    '., ' +
                                                                    value.startDate}
                                                            </div>
                                                            <div>
                                                                {value.participants.length &&
                                                                    value.participants.length + ' Pers.'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                );
            }
        }
    }

    getPriceDetails() {
        if (this.state != null) {
            const { data } = this.state;
            const isMediatedCruise = data?.frontendParams?.mediatedServices.cruise;

            if (data !== null && data?.frontendParams.price.total !== undefined) {
                return (
                    <div className="price-sec">
                        {convertPrice(data.frontendParams.price.total, 0, 0)}
                        <div className="price-small-print">
                            {isMediatedCruise ? (
                                <>
                                    (Gesamtpreis für alle Reisenden exklusive des Kreuzfahrtpreises)
                                    <Tooltip placement={window.$browserInfo.device === 'mobile' ? 'top' : 'right'}>
                                        Der Kreuzfahrtpreis wird Ihnen von der vermittelten Reederei separat mitgeteilt
                                    </Tooltip>
                                </>
                            ) : (
                                <>(Gesamtpreis für alle Reisenden)</>
                            )}
                        </div>
                    </div>
                );
            }
        }
    }

    summaryHeadline() {
        let hasFlightDetails = this.getFlightDetails() !== undefined;
        const { bookingData, travelType } = this.context;

        if (!bookingData || !travelType) {
            return null;
        }

        const isMediatedCruise = bookingData.data.frontendParams.mediatedServices.cruise;
        if (travelType === 'cruise') {
            if (isMediatedCruise) {
                return 'Leistungen';
            }
            return `${hasFlightDetails ? 'Flug + ' : ''}Kreuzfahrt`;
        } else if (travelType === 'package') {
            return `${hasFlightDetails ? 'Flug + ' : ''}Hotel`;
        } else {
            return null;
        }
    }

    render() {
        return (
            <div className={'sec travel-facts-booking'} key={''}>
                <div className="intro-line">
                    <div className="summary-headline">{this.summaryHeadline()}</div>
                    <div
                        className="trigger"
                        onClick={(e) =>
                            e.target.closest('.sec').classList.contains('active')
                                ? ((e.target.innerHTML = 'mehr Details'),
                                  e.target.closest('.sec').classList.remove('active'))
                                : ((e.target.innerHTML = 'weniger Details'),
                                  e.target.closest('.sec').classList.add('active'))
                        }>
                        mehr Details
                    </div>
                </div>

                <div className="content">
                    <div className="col inline">
                        <div className="main">
                            {this.getHotelDetails()}

                            {this.getFlightDetails()}

                            {this.getCruiseDetails()}

                            {this.getTransferDetails()}

                            {this.getExcursionDetails()}
                        </div>

                        {this.getPriceDetails()}
                    </div>
                </div>
            </div>
        );
    }
}

export default TravelFactsBooking;
